<script setup>
import { PageSidebar } from "@easy/ui/page-components";
import { FormInput, FormLabel, FormToggleSm, FormInputDate, FormInputUrl } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import { NotificationInfo } from "@easy/ui/notifications";
import cSaveButton from "@/shared/components/cSaveButton.vue";

import { useState, useActions } from "@/store/vuex-composition-mappers";

const { lang } = useState(["lang"]);
const { player, hasChanges } = useState("player", ["player", "hasChanges"]);
const { saveSnapshot } = useActions("player/projects", ["saveSnapshot"]);
</script>

<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("player.menu.settings") }} </template>
        <template #sidebarMain>
            <CardToggle :title="$t('player.settings.delayed_start')">
                <div class="space-y-5">
                    <FormInputDate
                        enableTimePicker
                        canReset
                        :title="$t('player.settings.start_date')"
                        :lang="lang"
                        :modelValue="player.releaseAt"
                        @valueAsDate="player.releaseAt = $event"
                    />
                    <NotificationInfo :closeButton="false">
                        {{ $t("player.settings.before_start_link_info") }}
                    </NotificationInfo>
                    <FormInputUrl
                        v-model="player.beforeReleaseLink"
                        :title="$t('player.settings.before_start_link')"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('player.menu.analitics')">
                <div class="space-y-5">
                    <FormInput
                        :title="$t('player.analitics.webhook_url')"
                        :placeholder="'Url'"
                        v-model="player.webhookUrl"
                        :help="$t('player.analitics.webhook_help')"
                    />
                    <FormLabel>
                        {{ $t("player.analitics.actions") }}
                    </FormLabel>

                    <template v-if="player.sendWebhooks">
                        <FormToggleSm
                            :title="$t('player.analitics.finish_file')"
                            v-model="player.sendWebhooks.finish"
                        />
                        <FormToggleSm
                            :title="$t('player.analitics.unfinish_file')"
                            v-model="player.sendWebhooks.unfinish"
                        />
                        <FormToggleSm
                            :title="$t('player.analitics.display')"
                            v-model="player.sendWebhooks.display"
                        />
                    </template></div
            ></CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>
